import React from 'react'
import Lottie from 'lottie-react'
import "./Reward_animation.css";


const Reward_animation = ({ animationData }) => {
    return (
        <section className='Reward_animation'>
            <Lottie
                animationData={animationData}
                loop={true}
                autoplay={true}
                className="arrow_lottie"
            />
        </section>
    )
}

export default Reward_animation;